<template>
  <b-card header-class="custom-header-bg">
    <template v-slot:header>
      <div class="border-left custom-header-border float-left mt-1">
        <span class="mb-0 h3 ml-2">編輯首頁輪播廣告</span>
      </div>
      <b-button variant="warning" class="border float-right" @click="onClickCancel">取消</b-button>
    </template>
    <b-row>
      <b-col cols="6" offset="3">
        <b-form @submit.prevent="onSubmit">
          <b-form-group
            id="name-input-group"
            label-for="name-input"
            description="輪播廣告名稱只是作為辨識多個輪播廣告用，不會顯示於輪播廣告中。"
            class="mb-3"
          >
            <template slot="label">
              <span class="text-danger">*</span>輪播廣告名稱
            </template>
            <b-form-input id="name-input" v-model="editName" :state="Boolean(editName.length)" required></b-form-input>
          </b-form-group>
          <b-form-file v-model="editFile" :state="Boolean(editFile)" browse-text="選擇檔案" placeholder="未選擇" accept=".jpg, .jpeg, .png"></b-form-file>
          <mark>只支援上傳jpg/png格式，圖片大小不得超過2MB。</mark>
          <b-row class="mt-3 mb-3">
            <b-col cols="6">
              <label for="start-datepicker">
                <span class="text-danger">*</span>
                輪播開始日期
              </label>
              <b-form-datepicker id="start-datepicker" v-model="editStart" class="mb-2" label-no-date-selected="選取日期" reset-button close-button></b-form-datepicker>
            </b-col>
            <b-col cols="6">
              <label for="end-datepicker">
                <span class="text-danger">*</span>
                輪播結束日期
              </label>
              <b-form-datepicker id="end-datepicker" v-model="editEnd" class="mb-2" label-no-date-selected="選取日期" reset-button close-button></b-form-datepicker>
            </b-col>
          </b-row>
          <b-form-group id="link-input-group" label="輪播廣告名稱：" label-for="link-input" class="mb-3">
            <b-form-input id="link-input" v-model="editLink" placeholder="請輸入輪播廣告連結" ></b-form-input>
          </b-form-group>
          <b-button variant="primary" type="submit" class="float-right">送出</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: 'homeset-ads-edit',
  props: {
    name: String,
    start: String,
    end: String,
    link: String
  },
  data () {
    return {
      editName: '',
      editFile: null,
      editStart: null,
      editEnd: null,
      editLink: ''
    }
  },
  methods: {
    onClickCancel () {
      this.$emit('cancel')
    },
    async onSubmit () {
      const { id, editName: name, editFile: file, editStart: start, editEnd: end, editLink: link } = this
      const data = { name, file, start, end, link }
      const fd = new FormData()
      for (const key in data) {
        if (data[key] !== 'Invalid date') {
          fd.append(key, data[key])
        }
      }
      try {
        if (id) {
          await this.$api.putAds(fd, id)
        } else {
          await this.$api.postAds(fd)
        }
        this.$bvToast.toast('資料已更新成功，稍後返回列表。', {
          variant: 'success',
          title: '資料更新'
        })
      } catch (err) {
        this.$bvToast.toast('連線失敗，資料更新未成功。', {
          variant: 'danger',
          title: '發生錯誤'
        })
      }
      this.$emit('submit')
    }
  },
  mounted () {
    if (this.name) this.editName = this.name
    if (this.start) this.editStart = this.start
    if (this.end) this.editEnd = this.end
    if (this.link) this.editLink = this.link
  }
}
</script>